module.exports = __webpack_public_path__ + "static/media/footerLogo.0eb2ab16.svg";